// The load-test boxes: one hidden, unrated, admin-only public box per crowd
// level, seated to the level's BIGGEST roster (the last level has no ceiling,
// so it gets LOAD_TEST_TOP_ROSTER), filled with bots within seconds. Each is
// the worst case its level's knobs have to carry, so a change to a level can be
// checked where it hurts most: can the host keep pace?
//
// One list, read by the edge-server (its PUBLIC_ROOMS) and the client (the
// /game/<base> pages and the Admin page), so the two can't drift from the
// ladder. The top box keeps the plain name "stress" (the original 40-seat box:
// /game/stress is bookmarked and in the docs).
import { CROWD_LADDER, crowdLevelRosters } from "./crowd.js";
import { sideOfKey, sizeKeyForPlayers } from "../core/arena-sizes.js";

export var LOAD_TEST_TOP_ROSTER = 40;

// The arena per roster: the standard size for that many players (core
// arena-sizes.js sizeKeyForPlayers), as its square's side. The box rolls the
// rectangle or the stadium of that size, like the real boxes.
function mapSizeFor(roster) {
    return sideOfKey(sizeKeyForPlayers(roster));
}

export var LOAD_TESTS = CROWD_LADDER.map(function (row) {
    var max = crowdLevelRosters(row.level).max;
    var capacity = max === Infinity ? LOAD_TEST_TOP_ROSTER : max;
    return {
        base: capacity === LOAD_TEST_TOP_ROSTER ? "stress" : "stress" + capacity,
        level: row.level,
        capacity: capacity,
        mapSize: mapSizeFor(capacity),
    };
});

export function isLoadTestBase(base) {
    return LOAD_TESTS.some(function (t) { return t.base === base; });
}
